import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DerivativeSearchProduct, DerivativeSearchValue, LeverageProductType } from '@zero/shared/util-models';
import { DerivativeType } from '../entities/derivative.type';

export const DerivativeSearchActions = createActionGroup({
  source: 'DerivativeSearch',
  events: {
    'Load Products': emptyProps(),
    'Set Products Loading': emptyProps(),
    'Set Long Or Short': props<{ leverageProductType: LeverageProductType }>(),
    'Set Isin': props<{ isin: string }>(),
    'Set Derivative Type': props<{ derivativeType: DerivativeType }>(),
    'Set Leverage': props<{ leverage: number }>(),
    'Set Strike': props<{ strike: DerivativeSearchValue }>(),
    'Set Duration': props<{ duration: DerivativeSearchValue }>(),
    'Set Factor': props<{ factor: DerivativeSearchValue }>(),
    'Set Cap': props<{ cap: DerivativeSearchValue }>(),
    'Set Quick Mode': props<{ quickMode: boolean }>(),
    'Reset State': emptyProps(),
  },
});

export const DerivativeSearchApiActions = createActionGroup({
  source: 'DerivativeSearch API',
  events: {
    'Load Products Success': props<{ products: DerivativeSearchProduct[]; highlightedProduct: DerivativeSearchProduct }>(),
    'Load Products Failure': props<{ error: HttpErrorResponse }>(),
  },
});
